import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import { CssBaseline } from '@mui/material';
import { ParallaxProvider } from 'react-scroll-parallax';
import './index.css';
import { AnimationProvider } from './components/AnimationContext';
import { NavbarStyleProvider } from './components/NavbarStyleContext';
import { ThemeContextProvider } from './contexts/ThemeContext';

async function prepare() {
  return
}

prepare().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root')!);
  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <ThemeContextProvider>
          <ParallaxProvider>
            <AnimationProvider>
              <NavbarStyleProvider>
                <CssBaseline />
                <App />
              </NavbarStyleProvider>
            </AnimationProvider>
          </ParallaxProvider>
        </ThemeContextProvider>
      </React.StrictMode>
    </Provider>
  );
});
